// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"FilterDesktop_toolbar__3Akxe","content":"FilterDesktop_content__Bmm26","filter":"FilterDesktop_filter__2B9cS"};